export enum BranchOfService {
  Airforce = 'Airforce',
  Army = 'Army',
  CoastGuard = 'Coast Guard',
  Marine = 'Marine',
  Navy = 'Navy',
}

export enum ActiveMilitaryPaygrade {
  E1 = 'E1',
  E2 = 'E2',
  E3 = 'E3',
  E4 = 'E4',
  E5 = 'E5',
  E6 = 'E6',
  E7 = 'E7',
  E8 = 'E8',
  E9 = 'E9',
  O1 = 'O1',
  O1E = 'O1E',
  O2 = 'O2',
  O2E = 'O2E',
  O3 = 'O3',
  O3E = 'O3E',
  O4 = 'O4',
  O5 = 'O5',
  O6 = 'O6',
  O7 = 'O7',
  O8 = 'O8',
  O9 = 'O9',
  O10 = 'O10',
  W1 = 'W1',
  W2 = 'W2',
  W3 = 'W3',
  W4 = 'W4',
  W5 = 'W5',
}

export enum GovernmentPaygrade {
  GS1 = 'GS1',
  GS2 = 'GS2',
  GS3 = 'GS3',
  GS4 = 'GS4',
  GS5 = 'GS5',
  GS6 = 'GS6',
  GS7 = 'GS7',
  GS8 = 'GS8',
  GS9 = 'GS9',
  GS10 = 'GS10',
  GS11 = 'GS11',
  GS12 = 'GS12',
  GS13 = 'GS13',
  GS14 = 'GS14',
  GS15 = 'GS15',
}

export enum RetiredMilitaryPaygrade {
  E1 = 'E1',
  E2 = 'E2',
  E3 = 'E3',
  E4 = 'E4',
  E5 = 'E5',
  E6 = 'E6',
  E7 = 'E7',
  E8 = 'E8',
  E9 = 'E9',
  O1 = 'O1',
  O1E = 'O1E',
  O2 = 'O2',
  O2E = 'O2E',
  O3 = 'O3',
  O3E = 'O3E',
  O4 = 'O4',
  O5 = 'O5',
  O6 = 'O6',
  O7 = 'O7',
  O8 = 'O8',
  O9 = 'O9',
  O10 = 'O10',
  W1 = 'W1',
  W2 = 'W2',
  W3 = 'W3',
  W4 = 'W4',
  W5 = 'W5',
}
